import { useWrapRequest } from '../../../../components/hooks/use-wrap-request';
import { Api } from '../../../../core/api';
import { injectTSDI } from '../../../../core/tsdi';

export function useOperationDetailsStore() {
    const { walletClient } = injectTSDI(Api);

    const operationDetails = useWrapRequest(
        async (operationId: number) => {
            const result =
                await walletClient.supportApi.walletSupportControllerGetAccountOperationDetails(
                    operationId
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    return {
        operationDetails
    };
}
